// extracted by mini-css-extract-plugin
export default {"options":"McqOptions_options__zGBg1","saving-text":"McqOptions_saving-text__glNTC"};